<template>
    <ThePage class="planogram-layout">
        <template v-slot:goback>
            <router-link :to="{ name: 'stocks.planograms' }"><i class="tlm-icon-chevron-left small mr-2" />Вернуться назад</router-link>
        </template>

        <template v-slot:title>
            <div class="d-flex flex-row">
                <div class="w-100">{{ $route.meta.title }}</div>
                <a target="_blank" :href="getKBLink('new_planogram')" class="btn btn-outline-primary text-center"><i class="tlm-icon-question-circle" /></a>
            </div>
        </template>

        <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="submit">
            <div class="d-flex flex-column flex-xl-row mb-5">
                <div class="right-column mb-3 mb-xl-0">
                    <div class="font-weight-bold mb-3 d-none d-sm-block">Название планограммы</div>
                    <div class="card">
                        <div class="card-body card-body-search">
                            <ValidationProvider v-errors.api vid="name" tag="div" class="form-group" rules="required|max:200">
                                <input v-model="form.name" v-focus maxlength="60" type="text" class="form-control" placeholder="Введите название">
                            </ValidationProvider>
                        </div>
                    </div>
                </div>

                <div class="flex-fill ml-xl-3">
                    <div class="font-weight-bold mb-3">Добавление позиции</div>

                    <div class="card flex-fill d-none d-xl-block">
                        <div class="card-body card-body-search">
                            <form-layout-add ref="formLayoutAdd" :has-loading="hasLoading" @add="productAdd" />
                        </div>
                    </div>

                    <button type="button" class="btn btn-lg-192 btn-outline-primary flex-fill d-xl-none" @click="showFormLayoutAdd = true">Добавить позицию</button>
                </div>
            </div>

            <!-- Моник -->
            <div class="d-none d-xl-flex flex-row mb-3">
                <div class="font-weight-bold flex-fill">Продукты и рецепты</div>
                <div v-feature="'loading'" class="font-weight-bold right-column ml-3">Ингредиенты</div>
            </div>

            <!-- Мобила + Моник -->
            <div class="d-flex flex-column flex-xl-row">
                <form-layout-products :products="products" :has-loading="hasLoading" class="flex-fill mb-3 mb-xl-0" @update="updateProduct" @remove="remove" />
                <form-layout-components v-feature="'loading'" :components="components" class="right-column ml-xl-3" @update="updateRecipeComponent" />
            </div>

            <div class="savebar">
                <button type="submit" class="btn btn-lg-192 btn-outline-primary bg-white text-primary" :disabled="invalid || pending">Сохранить</button>
            </div>
        </ValidationObserver>

        <TheModal v-if="showFormLayoutAdd" class="sm" @close="showFormLayoutAdd = false">
            <template v-slot:head>Добавить продукцию</template>
            <form-layout-add ref="formLayoutAdd" :has-loading="hasLoading" @add="productAdd" />
        </TheModal>
    </ThePage>
</template>

<script>
import ThePage from '@/components/ThePage'
import TheModal from '@/components/TheModal'

import FormLayoutAdd from '@/components/FormLayoutAdd'
import FormLayoutComponents from '@/components/FormLayoutComponents'
import FormLayoutProducts from '@/components/FormLayoutProducts'

import store from '@/store'
import layout from '@/store/modules/layout'

import { toastSuccess, toastError } from '@/dialogs'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'

import { fetchOptions as fetchProducts } from '@/components/SelectProduct'

import KBLinksService from '@/services/KBLinksService'

if (!store.state['planogram-layout']) {
    store.registerModule('planogram-layout', layout)
}

export default {
    components: {
        ThePage,
        FormLayoutAdd,
        FormLayoutComponents,
        FormLayoutProducts,
        ValidationObserver,
        ValidationProvider,
        TheModal
    },

    data() {
        return {
            form: {
                id: null,
                name: ''
            },

            pending: false,
            showFormLayoutAdd: false
        }
    },

    computed: {
        components() {
            return store.getters['planogram-layout/components']
        },

        products() {
            return store.getters['planogram-layout/products']
        },

        attributes() {
            return {
                id: this.form.id,
                name: this.form.name,
                ...store.getters['planogram-layout/normalized']
            }
        },
        hasLoading() {
            return this.$store.getters['company/hasLoading']
        }
    },

    destroyed() {
        store.commit('planogram-layout/flush')
    },

    methods: {
        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (!isValid) {
                return
            }

            const response = await this.$store.dispatch('planograms/store', this.attributes)

            if (response) {
                toastSuccess('Сохранено')
                this.$router.push({ name: 'stocks.planograms.show', params: { id: response.id } })
            } else {
                toastError('Ошибка')
                mixinApiErrors(this.$refs.obs, this.$store.state.planograms.error)
            }
        },

        productAdd({ product, product_number, max }) {
            store.commit('planogram-layout/add', { product, product_number, max })
            this.$refs.formLayoutAdd.reset()
            this.showFormLayoutAdd = false
        },

        updateRecipeComponent({ id, max }) {
            store.commit('planogram-layout/updateRecipeComponent', { id, max })
        },

        updateProduct({ index, product_number, max }) {
            store.commit('planogram-layout/updateProduct', { index, product_number, max })
        },

        remove(index) {
            store.dispatch('planogram-layout/remove', index)
        },

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    },

    async beforeRouteEnter(to, from, next) {
        const promiseList = [
            fetchProducts()
        ]

        if (to.params.id && to.params.id !== 'new') {
            promiseList.push(
                store.dispatch('planograms/fetch', to.params.id)
            )
        }

        const done = await Promise.all(promiseList)

        if (promiseList[1]) {
            if (done[1]) {
                store.commit('planogram-layout/init', done[1])

                return next(vm => {
                    vm.form.id = done[1].id
                    vm.form.name = done[1].name
                })
            } else {
                toastError(`Планограмма не найдена`)
                return next({ name: 'stocks.planograms' })
            }
        }

        return next()
    }
}
</script>
